import React, { useState } from "react";
import "./Login.css";
import { useAuth } from "../auth/AuthProvider";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import PasswordInput from "../components/PasswordInput";

function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const invite = params.get("invite") || undefined;

  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pending) return;
    if (password.length < 8) {
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setPending(true);
    try {
      await register({ email: email.trim(), password, displayName: displayName.trim(), invite });
      toast.success("Account created. Check your email to verify your account.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.message || "Registration failed.");
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-shell">
        <div className="auth-card">
          <h2 className="auth-title">Create your account</h2>
          <p className="auth-text">Register to get started with BIM Check.</p>

          <form onSubmit={submit}>
            <input className="auth-input" type="text" placeholder="Display name"
              value={displayName} onChange={(e) => setDisplayName(e.target.value)} autoComplete="name" autoFocus />
            <input className="auth-input" type="email" placeholder="Email"
              value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" required />
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Password (min 8 characters)" autoComplete="new-password" />
            <button type="submit" className="auth-btn auth-btnPrimary" disabled={pending}>
              {pending ? "Creating…" : "Create account"}
            </button>
          </form>

          <div className="auth-links">
            <Link to="/login">Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
